export default "__VITE_ASSET__de76695c__"